export const frontendURI = '/cat/labels/';
export const backendURI = `/api${frontendURI}`;
